export default __webpack_public_path__ + "img/a090bfe2b50b9744ccf728f74d75ac76.svg";